export const driverAttributes = `
  id
  name
  fleet_id
  assigned
  phone_number
  first_license_acquirement_date
  license_expiration_date
  license_category
  driver_code
`;

export default driverAttributes;
